var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogoDark(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 51,
    viewBox: "0 0 36 51",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.08632 4.64642H0V22.0041H3.08632V4.64642Z",
    fill: "#324a71"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.20131 0.939148H4.11499V45.2877H7.20131V0.939148Z",
    fill: "#324a71"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.3141 0H8.22778V51H11.3141V0Z",
    fill: "#324a71"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M15.4293 0.939148H12.343V37.1007H15.4293V0.939148Z",
    fill: "#324a71"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M19.5419 1.69281H16.4556V29.3693H19.5419V1.69281Z",
    fill: "#324a71"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M23.6571 0.939148H20.5708V37.1007H23.6571V0.939148Z",
    fill: "#324a71"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M27.7721 0H24.6858V51H27.7721V0Z",
    fill: "#324a71"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M31.8849 0.939148H28.7986V45.2877H31.8849V0.939148Z",
    fill: "#324a71"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M35.9999 4.64642H32.9136V22.0041H35.9999V4.64642Z",
    fill: "#324a71"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoDark);
export default __webpack_public_path__ + "static/media/logo_dark.b0b8b24b177be255e33ecf05835d10cd.svg";
export { ForwardRef as ReactComponent };